import Icon from '../components/Icon.vue'

Icon.register({
  bell: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 512c-35.3 0-64-28.7-64-64h127.9c0 35.3-28.6 64-64 64zM439.4 362.3c6 6.4 8.7 14.2 8.6 21.7-0.1 16.4-13 32-32.1 32h-383.8c-19.1 0-32-15.6-32.1-32 0-7.5 2.6-15.3 8.6-21.7 19.3-20.8 55.5-52 55.5-154.3 0-77.7 54.5-139.9 127.9-155.2v-20.8c0-17.7 14.3-32 32-32s32 14.3 32 32v20.8c73.5 15.3 127.9 77.5 127.9 155.2 0 102.3 36.2 133.5 55.5 154.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bell.js
// module id = 657
// module chunks = 0